export function useSavedViewEnabled(): boolean {
	return true;
}
